import { createOnboardingTodo } from 'lib/api/task/createOnboardingTodo'
import { useMutation } from '@tanstack/react-query'

const useCreateOnboardingTodoMutate = () => {
  return useMutation((payload) => createOnboardingTodo(payload))
}

export default useCreateOnboardingTodoMutate